// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Hyperlink Component */
.ids-hyperlink {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 1px solid transparent;
  border-radius: var(--ids-hyperlink-border-radius);
  cursor: var(--ids-hyperlink-cursor);
  display: inline-block;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-hyperlink-font-size);
  font-weight: var(--ids-hyperlink-font-weight);
  padding: var(--ids-space-3xs) var(--ids-space-2xs);
  position: relative;
  margin-block-start: -3px;
  margin-inline-start: -4px;
}
.ids-hyperlink.disabled, .ids-hyperlink[disabled] {
  cursor: var(--ids-cursor-default);
  pointer-events: none;
  user-select: none;
}
.ids-hyperlink.text-ellipsis {
  display: block;
  width: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-hyperlink:focus {
  outline: none;
}
.ids-hyperlink.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-hyperlink.semibold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-hyperlink.hitbox::after {
  content: "";
  display: block;
  height: var(--ids-size-40);
  top: 50%;
  left: 0;
  position: absolute;
  transform: translateY(-50%);
  width: 100%;
}
.ids-hyperlink {
  /* Ids Typography System */
}
.ids-hyperlink.ids-text-10 {
  font-size: var(--ids-font-size-3xs);
  text-transform: var(--ids-font-uppercase);
}
.ids-hyperlink.ids-text-12, .ids-hyperlink.ids-text-xs {
  font-size: var(--ids-font-size-2xs);
  text-transform: var(--ids-font-uppercase);
}
.ids-hyperlink.ids-text-14, .ids-hyperlink.ids-text-sm {
  font-size: var(--ids-font-size-xs);
}
.ids-hyperlink.ids-text-16, .ids-hyperlink.ids-text, .ids-hyperlink.ids-text-base {
  font-size: var(--ids-font-size-sm);
}
.ids-hyperlink.ids-text-20 {
  font-size: var(--ids-font-size-md);
}
.ids-hyperlink.ids-text-24, .ids-hyperlink.ids-text-lg {
  font-size: var(--ids-font-size-xl);
}
.ids-hyperlink.ids-text-28 {
  font-size: var(--ids-font-size-xl);
}
.ids-hyperlink.ids-text-32, .ids-hyperlink.ids-text-xl {
  font-size: var(--ids-font-size-2xl);
}
.ids-hyperlink.ids-text-40 {
  font-size: var(--ids-font-size-3xl);
}
.ids-hyperlink.ids-text-48 {
  font-size: var(--ids-font-size-4xl);
}
.ids-hyperlink.ids-text-60 {
  font-size: var(--ids-font-size-5xl);
}
.ids-hyperlink.ids-text-72 {
  font-size: var(--ids-font-size-6xl);
  margin-bottom: 0;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset) {
  color: var(--ids-hyperlink-color-text-default);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).show-visited-color:visited {
  color: var(--ids-hyperlink-color-text-visited);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset):focus {
  border: 1px solid var(--ids-hyperlink-color-text-default);
  box-shadow: var(--ids-shadow-focus);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset):hover:not([disabled]):not(.ids-text-decoration-hover):not(.disabled):not(.color-variant-breadcrumb), .ids-hyperlink:not(.ids-hyperlink-color-unset):active:not([disabled]):not(.ids-text-decoration-hover):not(.disabled):not(.color-variant-breadcrumb) {
  color: var(--ids-hyperlink-color-text-hover);
  text-decoration-line: underline;
  text-decoration-style: solid;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).disabled, .ids-hyperlink:not(.ids-hyperlink-color-unset)[disabled] {
  color: var(--ids-hyperlink-color-text-disabled);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).hide-focus:focus {
  border-color: var(--ids-color-transparent);
  box-shadow: none;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb {
  color: var(--ids-breadcrumb-color-text-default);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb.disabled, .ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb[disabled] {
  color: var(--ids-breadcrumb-color-text-disabled);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb.semibold {
  color: var(--ids-breadcrumb-color-text-selected);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb.semibold:hover {
  color: var(--ids-breadcrumb-color-text-selected);
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-breadcrumb:hover {
  color: var(--ids-breadcrumb-color-text-hover);
  text-decoration: underline;
}
.ids-hyperlink:not(.ids-hyperlink-color-unset).color-variant-alternate {
  color: var(--ids-breadcrumb-color-text-emphasis);
}
.ids-hyperlink.ids-hyperlink-color-unset:focus {
  --ids-box-shadowed-color-border: 1px solid var(--ids-hyperlink-color-text-default);
  --ids-box-shadow: var(--ids-box-shadow-focus);
}

.ids-text-decoration-none {
  text-decoration: none;
}
.ids-text-decoration-none:hover {
  text-decoration: none;
}

.ids-text-decoration-hover {
  text-decoration: none;
}
.ids-text-decoration-hover:hover {
  text-decoration: underline;
}

:host(:not([allow-empty-href=false])) .ids-hyperlink:not(.ids-text-decoration-none):not(.color-variant-breadcrumb):not(.ids-text-decoration-hover) {
  text-decoration: underline;
}

::slotted(ids-box:not([height])) {
  --ids-box-height: var(--ids-hyperlink-box-height);
}

::slotted(ids-box:not([width])) {
  --ids-box-width: var(--ids-hyperlink-box-width);
}

.ids-hyperlink.colspan ::slotted(ids-box:not([width])) {
  --ids-box-width: var(--ids-hyperlink-box-width-double);
}

::slotted(ids-box) {
  text-align: center;
  --ids-icon-height-default: var(--ids-space-2xl);
  --ids-icon-width-default: var(--ids-space-2xl);
  --ids-icon-color-default: var(--ids-hyperlink-box-icon-color-text-default);
  --ids-box-padding: var(--ids-space-xs);
}

::slotted(ids-box:hover) {
  --ids-box-shadowed-color-border: 1px solid var(--ids-hyperlink-box-color-border-default);
}

::slotted(ids-icon) {
  --ids-icon-color-default: var(--ids-hyperlink-color-text-default);
  display: inline;
  margin-inline-end: var(--ids-space-xs);
  top: var(--ids-space-2xs);
}

:host(.disabled) .ids-hyperlink,
:host([disabled]) .ids-hyperlink {
  color: var(--ids-hyperlink-color-text-disabled);
  cursor: var(--ids-cursor-default);
  pointer-events: none;
  user-select: none;
}
:host(.disabled) .ids-hyperlink ::slotted(ids-icon),
:host([disabled]) .ids-hyperlink ::slotted(ids-icon) {
  --ids-icon-color-default: var(--ids-hyperlink-color-text-disabled);
}

:host([clickable]) .ids-hyperlink {
  text-decoration: none !important;
  color: var(--ids-hyperlink-color-text-clickable);
}
:host([clickable]) .ids-hyperlink:hover {
  outline: none;
  color: var(--ids-hyperlink-color-text-clickable-highlighted);
  cursor: var(--ids-cursor-pointer);
}
:host([clickable]) .ids-hyperlink.is-focused {
  color: var(--ids-hyperlink-color-text-clickable-highlighted) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-hyperlink/ids-hyperlink.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,4BAAA;AAGA;ECOE,mCAAA;EACA,kCAAA;EDLA,6BAAA;EACA,iDAAA;EACA,mCAAA;EACA,qBAAA;EACA,+EAAA;EACA,yCAAA;EACA,6CAAA;EACA,kDAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA;AADF;AAGE;EAEE,iCAAA;EACA,oBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,wCAAA;AALJ;AAQE;EACE,4CAAA;AANJ;AASE;EACE,WAAA;EACA,cAAA;EACA,0BAAA;EACA,QAAA;EACA,OAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;AAPJ;AA3CA;EAqDE,0BAAA;AAPF;AAQE;EACE,mCAAA;EACA,yCAAA;AANJ;AASE;EAEE,mCAAA;EACA,yCAAA;AARJ;AAWE;EAEE,kCAAA;AAVJ;AAaE;EAGE,kCAAA;AAbJ;AAgBE;EACE,kCAAA;AAdJ;AAiBE;EAEE,kCAAA;AAhBJ;AAmBE;EACE,kCAAA;AAjBJ;AAoBE;EAEC,mCAAA;AAnBH;AAsBE;EACE,mCAAA;AApBJ;AAuBE;EACE,mCAAA;AArBJ;AAwBE;EACE,mCAAA;AAtBJ;AAyBE;EACE,mCAAA;EACA,gBAAA;AAvBJ;AA4BE;EACE,8CAAA;AA1BJ;AA4BI;EACE,8CAAA;AA1BN;AA6BI;EACE,yDAAA;EACA,mCAAA;AA3BN;AA8BI;EAEE,4CAAA;EACA,+BAAA;EACA,4BAAA;AA7BN;AAgCI;EAEE,+CAAA;AA/BN;AAkCI;EACE,0CAAA;EACA,gBAAA;AAhCN;AAsCI;EACE,+CAAA;AApCN;AAsCM;EAEE,gDAAA;AArCR;AAwCM;EACE,gDAAA;AAtCR;AAwCQ;EACE,gDAAA;AAtCV;AA0CM;EACE,6CAAA;EACA,0BAAA;AAxCR;AA4CI;EACE,gDAAA;AA1CN;AA8CE;EACE,kFAAA;EACA,6CAAA;AA5CJ;;AAgDA;EACE,qBAAA;AA7CF;AA+CE;EACE,qBAAA;AA7CJ;;AAiDA;EACE,qBAAA;AA9CF;AAgDE;EACE,0BAAA;AA9CJ;;AAmDE;EACE,0BAAA;AAhDJ;;AAqDA;EACE,iDAAA;AAlDF;;AAqDA;EACE,+CAAA;AAlDF;;AAqDA;EACE,sDAAA;AAlDF;;AAqDA;EACE,kBAAA;EAEA,+CAAA;EACA,8CAAA;EACA,0EAAA;EACA,sCAAA;AAnDF;;AAsDA;EACE,wFAAA;AAnDF;;AAuDA;EACE,iEAAA;EAEA,eAAA;EACA,sCAAA;EACA,yBAAA;AArDF;;AA0DE;;EACE,+CAAA;EACA,iCAAA;EACA,oBAAA;EACA,iBAAA;AAtDJ;AAwDI;;EACE,kEAAA;AArDN;;AA2DE;EACE,gCAAA;EACA,gDAAA;AAxDJ;AA2DE;EACE,aAAA;EACA,4DAAA;EACA,iCAAA;AAzDJ;AA4DE;EACE,uEAAA;AA1DJ","sourcesContent":["/* Ids Hyperlink Component */\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.ids-hyperlink {\n  @include mixins.antialiased();\n\n  border: 1px solid transparent;\n  border-radius: var(--ids-hyperlink-border-radius);\n  cursor: var(--ids-hyperlink-cursor);\n  display: inline-block;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: var(--ids-hyperlink-font-size);\n  font-weight: var(--ids-hyperlink-font-weight);\n  padding: var(--ids-space-3xs) var(--ids-space-2xs);\n  position: relative;\n  margin-block-start: -3px;\n  margin-inline-start: -4px;\n\n  &.disabled,\n  &[disabled] {\n    cursor: var(--ids-cursor-default);\n    pointer-events: none;\n    user-select: none;\n  }\n\n  &.text-ellipsis {\n    display: block;\n    width: inherit;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &.bold {\n    font-weight: var(--ids-font-weight-bold);\n  }\n\n  &.semibold {\n    font-weight: var(--ids-font-weight-semibold);\n  }\n\n  &.hitbox::after {\n    content: '';\n    display: block;\n    height: var(--ids-size-40);\n    top: 50%;\n    left: 0;\n    position: absolute;\n    transform: translateY(-50%);\n    width: 100%;\n  }\n\n  /* Ids Typography System */\n  &.ids-text-10 {\n    font-size: var(--ids-font-size-3xs);\n    text-transform: var(--ids-font-uppercase);\n  }\n\n  &.ids-text-12,\n  &.ids-text-xs {\n    font-size: var(--ids-font-size-2xs);\n    text-transform: var(--ids-font-uppercase);\n  }\n\n  &.ids-text-14,\n  &.ids-text-sm {\n    font-size: var(--ids-font-size-xs);\n  }\n\n  &.ids-text-16,\n  &.ids-text,\n  &.ids-text-base {\n    font-size: var(--ids-font-size-sm);\n  }\n\n  &.ids-text-20 {\n    font-size: var(--ids-font-size-md);\n  }\n\n  &.ids-text-24,\n  &.ids-text-lg {\n    font-size: var(--ids-font-size-xl);\n  }\n\n  &.ids-text-28 {\n    font-size: var(--ids-font-size-xl);\n  }\n\n  &.ids-text-32,\n  &.ids-text-xl {\n   font-size: var(--ids-font-size-2xl);\n  }\n\n  &.ids-text-40 {\n    font-size: var(--ids-font-size-3xl);\n  }\n\n  &.ids-text-48 {\n    font-size: var(--ids-font-size-4xl);\n  }\n\n  &.ids-text-60 {\n    font-size: var(--ids-font-size-5xl);\n  }\n\n  &.ids-text-72 {\n    font-size: var(--ids-font-size-6xl);\n    margin-bottom: 0;\n  }\n\n  // =========================================\n  // Theme colors are applied when `color=\"unset\"` is not set\n  &:not(.ids-hyperlink-color-unset) {\n    color: var(--ids-hyperlink-color-text-default);\n\n    &.show-visited-color:visited {\n      color: var(--ids-hyperlink-color-text-visited);\n    }\n\n    &:focus {\n      border: 1px solid var(--ids-hyperlink-color-text-default);\n      box-shadow: var(--ids-shadow-focus);\n    }\n\n    &:hover:not([disabled]):not(.ids-text-decoration-hover):not(.disabled):not(.color-variant-breadcrumb),\n    &:active:not([disabled]):not(.ids-text-decoration-hover):not(.disabled):not(.color-variant-breadcrumb) {\n      color: var(--ids-hyperlink-color-text-hover);\n      text-decoration-line: underline;\n      text-decoration-style: solid;\n    }\n\n    &.disabled,\n    &[disabled] {\n      color: var(--ids-hyperlink-color-text-disabled);\n    }\n\n    &.hide-focus:focus {\n      border-color: var(--ids-color-transparent);\n      box-shadow: none;\n    }\n\n\n    // ===============================================\n    // Color Variants\n    &.color-variant-breadcrumb {\n      color: var(--ids-breadcrumb-color-text-default);\n\n      &.disabled,\n      &[disabled] {\n        color: var(--ids-breadcrumb-color-text-disabled);\n      }\n\n      &.semibold {\n        color: var(--ids-breadcrumb-color-text-selected);\n\n        &:hover {\n          color: var(--ids-breadcrumb-color-text-selected);\n        }\n      }\n\n      &:hover {\n        color: var(--ids-breadcrumb-color-text-hover);\n        text-decoration: underline;\n      }\n    }\n\n    &.color-variant-alternate {\n      color: var(--ids-breadcrumb-color-text-emphasis);\n    }\n  }\n\n  &.ids-hyperlink-color-unset:focus {\n    --ids-box-shadowed-color-border: 1px solid var(--ids-hyperlink-color-text-default);\n    --ids-box-shadow: var(--ids-box-shadow-focus);\n  }\n}\n\n.ids-text-decoration-none {\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.ids-text-decoration-hover {\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n:host(:not([allow-empty-href='false'])) {\n  .ids-hyperlink:not(.ids-text-decoration-none):not(.color-variant-breadcrumb):not(.ids-text-decoration-hover) {\n    text-decoration: underline;\n  }\n}\n\n// Box Style Links\n::slotted(ids-box:not([height])) {\n  --ids-box-height: var(--ids-hyperlink-box-height);\n}\n\n::slotted(ids-box:not([width])) {\n  --ids-box-width: var(--ids-hyperlink-box-width);\n}\n\n.ids-hyperlink.colspan ::slotted(ids-box:not([width])) {\n  --ids-box-width: var(--ids-hyperlink-box-width-double);\n}\n\n::slotted(ids-box) {\n  text-align: center;\n\n  --ids-icon-height-default: var(--ids-space-2xl);\n  --ids-icon-width-default: var(--ids-space-2xl);\n  --ids-icon-color-default: var(--ids-hyperlink-box-icon-color-text-default);\n  --ids-box-padding: var(--ids-space-xs);\n}\n\n::slotted(ids-box:hover) {\n  --ids-box-shadowed-color-border: 1px solid var(--ids-hyperlink-box-color-border-default);\n}\n\n// Icons with the link\n::slotted(ids-icon) {\n  --ids-icon-color-default: var(--ids-hyperlink-color-text-default);\n\n  display: inline;\n  margin-inline-end: var(--ids-space-xs);\n  top: var(--ids-space-2xs);\n}\n\n:host(.disabled),\n:host([disabled]) {\n  .ids-hyperlink {\n    color: var(--ids-hyperlink-color-text-disabled);\n    cursor: var(--ids-cursor-default);\n    pointer-events: none;\n    user-select: none;\n\n    ::slotted(ids-icon) {\n      --ids-icon-color-default: var(--ids-hyperlink-color-text-disabled);\n    }\n  }\n}\n\n:host([clickable]) {\n  .ids-hyperlink {\n    text-decoration: none !important;\n    color: var(--ids-hyperlink-color-text-clickable);\n  }\n\n  .ids-hyperlink:hover {\n    outline: none;\n    color: var(--ids-hyperlink-color-text-clickable-highlighted);\n    cursor: var(--ids-cursor-pointer);\n  }\n\n  .ids-hyperlink.is-focused  {\n    color: var(--ids-hyperlink-color-text-clickable-highlighted) !important;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
